import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLFormElement> {
  static targets = ["field", "body", "submit"]

  declare readonly fieldTargets: Array<HTMLInputElement | HTMLTextAreaElement>
  declare readonly bodyTarget: HTMLTextAreaElement
  declare readonly submitTarget: HTMLButtonElement

  connect() {
    this.refresh()
  }

  subjectChanged({ params }: { params: { placeholder: string } }) {
    this.bodyTarget.placeholder = params.placeholder
  }

  refresh() {
    this.submitTarget.disabled = this.fieldTargets.some((field) => field.value.trim() === "")
  }
}
